export default from './LoanTermsInfo';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanTermsInfo/index.js